import type {Action} from 'redux';

import storage from '@deezer/next/shared/utils/storage';
import {StorageKeys} from '@constants/storageKeys';

export enum AppliedFiltersActionType {
	UPDATE_COUNTRY_FILTER = 'appliedFilters/UPDATE_COUNTRY_FILTERS',
}

export interface UpdateCountryFilterAction extends Action {
	type: AppliedFiltersActionType.UPDATE_COUNTRY_FILTER;
	countryCode: string;
}

export function updateCountryFilter(
	countryCode: string,
): UpdateCountryFilterAction {
	return {
		type: AppliedFiltersActionType.UPDATE_COUNTRY_FILTER,
		countryCode,
	};
}

// TODO there is likely a better way to handle that, like directly in the clean function of the storage
// This is an helper function not an action
export const resetFilters = () => {
	storage.set(StorageKeys.END_DATE, null);
	storage.set(StorageKeys.START_DATE, null);
	storage.set(StorageKeys.COUNTRY, null);
	storage.set(StorageKeys.OFFER, 'all');
};
